import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 * Los cuatro números de arriba de una bandeja de alertas vigentes: Vigentes · Críticas · Aparecieron
 * hoy · Silenciadas. Salió de `ClientAlertsView` (card j61xJLod) para que «Ahora» del Centro de
 * Alertas (F3) dibuje los mismos, con las mismas clases.
 *
 * `summary` es el de `alertsSummary` (`client/panel_v11/alerts/clientAlertsLogic.js`): describe TODO,
 * los filtros no lo mueven. `activeHint` (opcional) va debajo de Vigentes: «Ahora» dice ahí en cuántos
 * clientes están. `guideAnchor`: el resultado de `anchorAttr(...)` cuando una guía apunta a los números
 * (lo pasa «Ahora»; la pantalla del cliente no).
 */
export function AlertKpis({summary, activeHint = null, guideAnchor = {}}) {
    const {t} = useTranslation();
    return (
        <div className="cav-kpis" {...guideAnchor}>
            <div className="cav-kpi">
                <span className="cav-kpi__label">{t('client_alerts.kpi_active')}</span>
                <span className={`cav-kpi__value${summary.active ? ' -alert' : ' -ok'}`}>{summary.active}</span>
                {activeHint && <span className="cav-kpi__sub">{activeHint}</span>}
            </div>
            <div className="cav-kpi">
                <span className="cav-kpi__label">{t('client_alerts.kpi_critic')}</span>
                <span className={`cav-kpi__value${summary.critic ? ' -critic' : ''}`}>{summary.critic}</span>
            </div>
            <div className="cav-kpi">
                <span className="cav-kpi__label">{t('client_alerts.kpi_today')}</span>
                <span className="cav-kpi__value">{summary.today}</span>
                <span className="cav-kpi__sub">{t('client_alerts.kpi_today_sub')}</span>
            </div>
            <div className="cav-kpi">
                <span className="cav-kpi__label">{t('client_alerts.kpi_snoozed')}</span>
                <span className="cav-kpi__value -muted">{summary.snoozed}</span>
                {summary.snoozedThisWeek > 0 && (
                    <span className="cav-kpi__sub">
                        {t('client_alerts.kpi_snoozed_sub', {count: summary.snoozedThisWeek})}
                    </span>
                )}
            </div>
        </div>
    );
}
